/**
 * store/auth.store.ts — CLI-450
 * Zustand-стор авторизации пациента.
 * Токены хранятся в localStorage (httpOnly cookies требуют CORS-настройки сервера).
 */
import { create } from 'zustand';

export interface PatientProfile {
  id: string;
  firstName: string;
  lastName: string;
  middleName: string | null;
  birthDate: string;
  gender: string;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  patient: PatientProfile | null;
  clinicId: string | null;
  setAuth: (accessToken: string, refreshToken: string, patient: PatientProfile, clinicId: string) => void;
  /** Атомарно обновляет оба токена при ротации (CLI-450: token rotation). */
  setTokens: (accessToken: string, refreshToken: string) => void;
  setAccessToken: (token: string) => void;
  logout: () => void;
}

const LS_ACCESS  = 'cp_access';
const LS_REFRESH = 'cp_refresh';
const LS_PATIENT = 'cp_patient';
const LS_CLINIC  = 'cp_clinic';

export const useAuthStore = create<AuthState>((set) => ({
  accessToken:  localStorage.getItem(LS_ACCESS),
  refreshToken: localStorage.getItem(LS_REFRESH),
  patient:      JSON.parse(localStorage.getItem(LS_PATIENT) ?? 'null') as PatientProfile | null,
  clinicId:     localStorage.getItem(LS_CLINIC),

  setAuth: (accessToken, refreshToken, patient, clinicId) => {
    localStorage.setItem(LS_ACCESS,  accessToken);
    localStorage.setItem(LS_REFRESH, refreshToken);
    localStorage.setItem(LS_PATIENT, JSON.stringify(patient));
    localStorage.setItem(LS_CLINIC,  clinicId);
    set({ accessToken, refreshToken, patient, clinicId });
  },

  setTokens: (accessToken, refreshToken) => {
    localStorage.setItem(LS_ACCESS, accessToken);
    localStorage.setItem(LS_REFRESH, refreshToken);
    set({ accessToken, refreshToken });
  },

  setAccessToken: (token) => {
    localStorage.setItem(LS_ACCESS, token);
    set({ accessToken: token });
  },

  logout: () => {
    localStorage.removeItem(LS_ACCESS);
    localStorage.removeItem(LS_REFRESH);
    localStorage.removeItem(LS_PATIENT);
    localStorage.removeItem(LS_CLINIC);
    set({ accessToken: null, refreshToken: null, patient: null, clinicId: null });
  },
}));
